import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export function stripHtml(html: string): string {
    return (html ?? '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim();
}

@Component({
    selector: 'app-comment-cell-renderer',
    standalone: true,
    template: `
        <div class="comment-preview-cell">
            <span class="preview" [title]="plain">{{ plain || '' }}</span>
            <i class="fa fa-pencil edit-icon"></i>
        </div>
    `,
    styles: [`
        :host { display: block; overflow: hidden; cursor: pointer; }
        .comment-preview-cell { display: flex; align-items: center; width: 100%; overflow: hidden; gap: 4px; }
        .preview { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .edit-icon { color: #bbb; font-size: 11px; flex-shrink: 0; }
    `]
})
export class CommentCellRendererComponent implements ICellRendererAngularComp {
    plain = '';

    agInit(params: ICellRendererParams): void {
        this.refresh(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.plain = stripHtml(params.value);
        return true;
    }
}
